export const types = [
  // {
  //   label: "全部",
  //   labelEn: "All",
  //   value: ""
  // },
  {
    label: "所有",
    labelEn: "All",
    value: "All",
  },
  {
    label: "名人",
    labelEn: "Celebrities",
    value: "网红名人",
  },
  {
    label: "娱乐",
    labelEn: "Entertaiment",
    value: "娱乐&特效",
  },
  {
    label: "才艺",
    labelEn: "Talent",
    value: "唱歌跳舞",
  },
  {
    label: "Vlog",
    labelEn: "Vlog",
    value: "Vlog",
  },
  {
    label: "美妆护理",
    labelEn: "Beauty care",
    value: "美妆护理",
  },
  {
    label: "运动",
    labelEn: "Sports",
    value: "运动",
  },
  {
    label: "媒体",
    labelEn: "Media",
    value: "渠道",
  },
  {
    label: "艺术",
    labelEn: "Art",
    value: "文学艺术",
  },
  {
    label: "科学教育",
    labelEn: "Science&Education",
    value: "科学教育",
  },
  {
    label: "美食",
    labelEn: "Food",
    value: "美食菜谱",
  },
  {
    label: "宠物",
    labelEn: "Pets",
    value: "宠物",
  },
  {
    label: "时尚",
    labelEn: "Fashion",
    value: "时尚&穿搭",
  },
  {
    label: "旅游",
    labelEn: "Travel",
    value: "旅游",
  },
  {
    label: "品牌",
    labelEn: "Brand",
    value: "品牌",
  },
  {
    label: "编程",
    labelEn: "Programming",
    value: "IT",
  },
  {
    label: "特效&剪辑",
    labelEn: "Effects&Montage",
    value: "网络",
  },
  {
    label: "生活",
    labelEn: "Life style",
    value: "生活",
  },
  {
    label: "健康",
    labelEn: "Health",
    value: "健康",
  },
  {
    label: "KOL",
    labelEn: "Key Opinion Leader",
    value: "权威顾问",
  },
  {
    label: "科技",
    labelEn: "Technology",
    value: "科技&电子",
  },
  {
    label: "金融",
    labelEn: "Finance",
    value: "金融经济",
  },
  {
    label: "游戏",
    labelEn: "Games",
    value: "游戏",
  },
  {
    label: "政府",
    labelEn: "Government",
    value: "政府",
  },
  {
    label: "非政府组织",
    labelEn: "NGO",
    value: "非政府组织",
  },
  {
    label: "服务",
    labelEn: "Service",
    value: "专业服务",
  },
  {
    label: "其他",
    labelEn: "Other",
    value: "其他",
  },
];

export const convertToI18 = (labelValue: number, needPrefix = false) => {
  if (labelValue === null || labelValue === undefined) return "--";
  const prefix =
    labelValue > 0 ? (needPrefix ? "+" : "") : labelValue < 0 ? "-" : "";
  // Nine Zeroes for Billions
  const val =
    Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(1) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(1) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(1) + "K"
      : Math.abs(Number(labelValue));
  return prefix + val.toString();
};
